import { render, staticRenderFns } from "./BaseTelInput.vue?vue&type=template&id=064c1b7c&scoped=true&"
import script from "./BaseTelInput.vue?vue&type=script&lang=ts&"
export * from "./BaseTelInput.vue?vue&type=script&lang=ts&"
import style0 from "./BaseTelInput.vue?vue&type=style&index=0&id=064c1b7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064c1b7c",
  null
  
)

export default component.exports